import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <div className="logo">
          <Link to="/">
            <h1>CTO</h1>
            <span>Crypto Trail Officer</span>
          </Link>
        </div>
        
        <div className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul>
            <li><Link to="/#features" onClick={() => setIsMenuOpen(!isMenuOpen)}>Özellikler</Link></li>
            <li><Link to="/#ai" onClick={() => setIsMenuOpen(!isMenuOpen)}>CTO AI</Link></li>
            <li><Link to="/#tracking" onClick={() => setIsMenuOpen(!isMenuOpen)}>Piyasa Takibi</Link></li>
            <li><Link to="/#download" onClick={() => setIsMenuOpen(!isMenuOpen)}>İndir</Link></li>
            <li><Link to="/contactus">Bize Ulaşın</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 